const getOverrideParam = (
  urlSearchParams: URLSearchParams,
  overrideParamName: string,
  override: string | null | undefined
): string | null => {
  if (override) {
    return override;
  }
  return urlSearchParams.get(overrideParamName);
};

export const addFiltersToUrl = (
  url: string,
  urlSearchParams: URLSearchParams,
  overrideParamName: string,
  override?: string | null
) => {
  let modifiedUrl = url;
  const overrideParam = getOverrideParam(urlSearchParams, overrideParamName, override);

  if (overrideParam) {
    modifiedUrl += `?${overrideParamName}=${overrideParam}`;
  }
  let firstParam = !overrideParam;

  urlSearchParams.forEach((value, key) => {
    if (key !== overrideParamName) {
      if (firstParam) {
        modifiedUrl += '?';
      } else {
        modifiedUrl += '&';
      }
      modifiedUrl += `${key === 'frameId' ? 'frameIds' : key}=${value}`;
    }
    firstParam = false;
  });
  return modifiedUrl;
};
